<script lang="ts">
	import PreloadingSpinner from '@app/components/loaders/PreloadingSpinner.svelte';
	import { signInUpModalStore } from '@app/stores/signInUpModal';
	import { urls } from '@app/urls';
	import { snackbar, viewport } from '@wiseed/wikit';
	import { navigating, page, updated } from '$app/stores';
	import { afterNavigate, beforeNavigate, goto } from '$app/navigation';
	import '@app/app.css';
	import { onMount } from 'svelte';
	import { detectBreakpoint } from '@wiseed/wikit';
	import ExternalScripts from '@app/components/ExternalScripts.svelte';
	import Banners from '@app/components/Banners.svelte';
	import { getTrackingUserStatus } from '@app/utils/user';

	/* START AUTH MODAL */
	let authModal;

	const loadAuthModal = async () => {
		const { default: SignInUpModal } = await import(
			'../components/sign-in-up-modal/SignInUpModal.svelte'
		);
		authModal = SignInUpModal;
	};

	const closeAuthModal = () => {
		if ($signInUpModalStore.isOpenFromRefreshToken) {
			goto(urls.HOME);
		}
		signInUpModalStore.close();
	};

	$: if ($signInUpModalStore.isOpen) {
		loadAuthModal();
	} else {
		authModal = null;
	}
	/* END AUTH MODAL */

	/* START SNACKBAR */
	let snackbarComponent;

	async function loadSnackbar() {
		const { Snackbar: Snackbar } = await import('@wiseed/wikit');
		snackbarComponent = Snackbar;
	}

	$: if ($snackbar.isOpen) {
		loadSnackbar();
	} else {
		snackbarComponent = null;
	}
	/* END SNACKBAR */

	const updateViewport = (breakpoint) => {
		let size = null;

		breakpoint.forEach(({ name, mq }) => {
			if (!mq || mq.matches) {
				size = name;
			}
		});

		$viewport = {
			isMobile: size === 'mobile',
			isTablet: size === 'tablet',
			isDesktop: size === 'desktop'
		};
	};

	beforeNavigate(({ willUnload, to }) => {
		if ($updated && !willUnload && to?.url) {
			location.href = to.url.href;
		}
	});

	onMount(async () => {
		const breakpointConfig = detectBreakpoint(updateViewport);
		updateViewport(breakpointConfig);
	});
	afterNavigate(() => {
		addDataLayerEvent();
	});

	const addDataLayerEvent = () => {
		const { data: { user = null } = {} } = $page || null;
		const { title } = document || null;

		const isLogged = !!user;

		const dataLayerObject = {
			event: 'pageView',
			documentTitle: title || document.title,
			...(isLogged && { id: user.id, status: getTrackingUserStatus(user) })
		};

		(window.dataLayer = window.dataLayer || []).push(dataLayerObject);
	};
</script>

<Banners />
{#if $navigating && !$page.url.pathname.startsWith(urls.PROJECTS.INDEX) && $page.url.pathname !== urls.NEWS_FEED}
	<PreloadingSpinner />
{/if}

<slot />

<svelte:component this={authModal} on:closeModal={() => closeAuthModal()} />
<svelte:component this={snackbarComponent} />
<ExternalScripts />
